<button *ngIf="currentItemCount && currentItemCount < totalItemCount" type="button" class="btn btn-primary mt-3" (click)="clickMore()">
  meer <i class="fas fa-angle-double-right collapse-button"></i>
</button>